import { ADMIN } from "./admin/admin-api-urls";
import { CORE } from "./core-api-urls";
import { DOCTORS } from "./doctors-api-urls";
import { ROLEPLAY } from "./roleplay-api-urls";
import { USER_FEEDBACK } from "./user-feedback-api-urls";
import { CONTACT_CENTER } from "./contact-center-api-urls";
import { ONBOARDING } from "./onboarding-api-urls";
import { QUIZ } from "./quiz-api-urls";

export const API_URLS = {
    CORE: CORE,
    ROLEPLAY: ROLEPLAY,
    DOCTORS: DOCTORS,
    USER_FEEDBACK: USER_FEEDBACK,
    ADMIN: ADMIN,
    CONTACT_CENTER: CONTACT_CENTER,
    ONBOARDING: ONBOARDING,
    QUIZ: QUIZ
};